exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.uk-message{color:#707372}@media (max-width:767px){height:50px;padding-bottom:0;.uk-message{-ms-flex-preferred-size:100%;flex-basis:100%;display:-ms-flexbox;display:flex;font-size:13px}[dir] .uk-message{padding-bottom:30px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/front-desk/front-desk.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/front-desk/front-desk.component.scss
// module chunks = 0